/**
 * Enum xử lý ở điều chỉnh tồn kho
 * NVTOAN2 09/07/2022
 */
export default {
  All: null,
  Excuted: true,
  NotExcute: false,
};
